module.exports = __webpack_public_path__ + "static/media/jardines01.923da643.jpg";